// test24
(24 && 0);
